import React from 'react';
import { CTAButton } from './ui/CTAButton';
import { ShieldCheckIcon, LockIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="pt-28 pb-16 px-4 text-center" data-id="element-156">
      <div className="max-w-4xl mx-auto" data-id="element-157">
        <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-black text-brand-dark mb-6 leading-tight tracking-tight" data-id="element-158">
          De Empleado a Dueño de tu Tiempo: <br data-id="element-159" />
          Aprendé el Oficio que <br data-id="element-160" />
          <span className="text-brand-primary underline decoration-brand-secondary decoration-4 md:decoration-8 underline-offset-4 md:underline-offset-8" data-id="element-161">
            Más Paga en Argentina
          </span>
        </h1>

        <p className="text-base sm:text-lg md:text-xl text-gray-700 max-w-3xl mx-auto mb-6 leading-relaxed font-medium" data-id="element-162">
          El sistema completo para instalar, reparar y diagnosticar aires y
          heladeras — y empezar a generar ingresos reales esta semana.
        </p>

        <div className="mb-4" data-id="element-163">
          <img src="https://cdn.magicpatterns.com/uploads/bLuQU16W7zusoDyUoMcC1z/ChatGPT_Image_25_mar_2026,_09_05_09_p.m..png" alt="Maestro de Refrigeración - Pack Completo" className="w-full max-w-xs mx-auto" data-id="element-164" />
        </div>

        <div className="flex flex-col items-center gap-2 mb-10" data-id="element-165">
          <div className="flex gap-3" data-id="element-166">
            <span className="flex items-center gap-1.5 bg-white shadow-sm px-3 py-1.5 rounded-lg text-sm font-semibold text-gray-800 border border-gray-100" data-id="element-167">
              📄 100% Digital
            </span>
            <span className="flex items-center gap-1.5 bg-white shadow-sm px-3 py-1.5 rounded-lg text-sm font-semibold text-gray-800 border border-gray-100" data-id="element-168">
              ⚡ Acceso Inmediato
            </span>
          </div>
          <span className="flex items-center gap-1.5 bg-white shadow-sm px-3 py-1.5 rounded-lg text-sm font-semibold text-gray-800 border border-gray-100" data-id="element-169">
            🇦🇷 Hecho en Argentina
          </span>
        </div>

        <div className="max-w-2xl mx-auto mb-6" data-id="element-170">
          <CTAButton text="🔥 → QUIERO EMPEZAR HOY" isLink={true} data-id="element-171" />
        </div>

        <div className="max-w-xl mx-auto mb-8 bg-gray-50 border border-gray-200 rounded-lg p-4" data-id="element-172">
          <p className="text-sm font-bold text-gray-800 mb-2" data-id="element-173">
            🔒 Tu pago es 100% seguro
          </p>
          <div className="text-xs text-gray-700 space-y-1 text-left" data-id="element-174">
            <p data-id="element-175">✅ No necesitás tener cuenta en Mercado Pago</p>
            <p data-id="element-176">✅ Podés pagar con tarjeta de débito o crédito</p>
            <p data-id="element-177">✅ También aceptamos transferencia bancaria o CVU</p>
            <p data-id="element-178">✅ Tus datos están protegidos en todo momento</p>
            <p className="pt-2" data-id="element-179">
              📩 En menos de 5 minutos recibís todo en tu email
            </p>
            <p data-id="element-180">⚠️ Si no lo ves, revisá Spam o Promociones</p>
          </div>
        </div>

        <div className="mb-6" data-id="element-181">
          <img src="https://cdn.magicpatterns.com/uploads/iNdd7dNPFTmkMXnAUq87Qt/jo3l6snt.png" alt="Garantía 7 Días de Reembolso" className="w-40 mx-auto" data-id="element-182" />
        </div>

        <div className="flex flex-wrap justify-center items-center gap-6 text-sm md:text-base text-gray-600 font-medium mb-6" data-id="element-183">
          <span className="flex items-center gap-1" data-id="element-184">
            <ShieldCheckIcon className="w-5 h-5 text-brand-green" data-id="element-185" /> Garantía 7
            días sin preguntas
          </span>
          <span className="flex items-center gap-1" data-id="element-186">
            <LockIcon className="w-5 h-5 text-gray-500" data-id="element-187" /> Pago 100% seguro vía
            Mercado Pago
          </span>
        </div>

        <div className="max-w-lg mx-auto bg-gray-50 border border-gray-200 rounded-lg p-3" data-id="element-188">
          <div className="text-xs text-gray-700 space-y-1 text-center" data-id="element-189">
            <p data-id="element-190">🔒 Pago seguro · No necesitás cuenta en MP</p>
            <p data-id="element-191">💳 Débito · Crédito · Transferencia · CVU</p>
            <p data-id="element-192">📩 Acceso inmediato por email</p>
          </div>
        </div>
      </div>
    </section>;
}